import { render, staticRenderFns } from "./TopBlessors.vue?vue&type=template&id=6396b994&"
import script from "./TopBlessors.vue?vue&type=script&lang=js&"
export * from "./TopBlessors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports